module.exports = __webpack_public_path__ + "assets/img/ambition-3.11f860df.svg";